module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content order-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [(!_vm.statusShow) ? _c('div', {
    staticClass: "order-number"
  }, [_c('span', {
    staticClass: "main-header-login"
  }, [_vm._v("订单号：" + _vm._s(_vm.afterSalesDetail.afterSn))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-status"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), (_vm.status1 == 1) ? _c('li', {
    staticClass: "order-detail-two order-status-two order-status-default yiwancheng"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("商家审核中")])]) : (_vm.status1 == 2) ? _c('li', {
    staticClass: "order-detail-two order-status-two order-status-default yiwancheng"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("商家同意售后")])]) : (_vm.status1 == 3) ? _c('li', {
    staticClass: "order-detail-two order-status-two order-status-default refuse"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("商家拒绝")])]) : _vm._e(), _vm._v(" "), (_vm.status2 == 1) ? _c('li', {
    staticClass: "order-detail-three order-status-two order-status-default yiwancheng"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("商品回寄，商家处理中")])]) : (_vm.status2 == 2) ? _c('li', {
    staticClass: "order-detail-three order-status-two order-status-default yiwancheng"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("退款成功")])]) : _c('li', {
    staticClass: "order-detail-three order-status-two order-status-default"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("等待中")])]), _vm._v(" "), (_vm.status3 == 2) ? _c('li', {
    staticClass: "order-detail-four order-status-two order-status-default yiwancheng"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("售后完成")])]) : (_vm.status3 == 1) ? _c('li', {
    staticClass: "order-detail-four order-status-two order-status-default"
  }) : _c('li', {
    staticClass: "order-detail-four order-status-two order-status-default"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("售后完成")])])])]), _vm._v(" "), _c('div', {
    staticClass: "afs-content-wrap mar-bot-20"
  }, [_c('div', {
    staticClass: "afs-big-title"
  }, [_vm._v("处理环节：")]), _vm._v(" "), _c('div', [(_vm.status3 == 2) ? _c('div', {
    staticClass: "afs-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap",
    class: {
      'current': _vm.current == 3
    }
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("售后完成")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：商家")])])])]) : _vm._e(), _vm._v(" "), (_vm.status2 == 2) ? _c('div', {
    staticClass: "afs-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap",
    class: {
      'current': _vm.current == 3
    }
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("退款成功")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：商家")])])])]) : _vm._e(), _vm._v(" "), (_vm.status2 == 1) ? _c('div', {
    staticClass: "afs-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap",
    class: {
      'current': _vm.current == 2
    }
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("退款成功")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：商家")])])])]) : _vm._e(), _vm._v(" "), (_vm.status1 == 1) ? _c('div', {
    staticClass: "afs-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap",
    class: {
      'current': _vm.current == 2
    }
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("商家已收到申请，正在处理中")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：商家")])])])]) : _vm._e(), _vm._v(" "), (_vm.status1 == 2) ? _c('div', {
    staticClass: "afs-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap",
    class: {
      'current': _vm.current == 2
    }
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("商家已经同意售后")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：商家")]), _vm._v(" "), (_vm.showLogistics) ? _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("物流信息：")]) : _vm._e(), _vm._v(" "), (_vm.showLogistics) ? _c('div', [_c('div', {
    staticClass: "order-info-content"
  }, [_c('div', {
    staticClass: "order-logistics-info"
  }, [_c('div', [_vm._v("\n                        物流公司：\n                        "), _c('span', [_vm._v(_vm._s(_vm.logisticsDetail.company))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', [_vm._v("\n                        物流单号：\n                        "), _c('span', [_vm._v(_vm._s(_vm.logisticsDetail.no))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-logistics-content afsOrder"
  }, _vm._l((_vm.logisticsDetail.list), function(item, index) {
    return _c('div', {
      staticClass: "order-logistics-item-wrap"
    }, [_c('div', {
      staticClass: "order-logistics-item",
      class: {
        'current': index == 0
      }
    }, [_c('span', [_vm._v(_vm._s(item.datetime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remark))])])])
  }), 0)])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.status1 == 3) ? _c('div', {
    staticClass: "afs-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap",
    class: {
      'current': _vm.current == 2
    }
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("商家拒绝售后")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：商家")])])])]) : _vm._e(), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', [(_vm.statusShow) ? _c('div', [_c('div', {
    staticClass: "afs-block-title"
  }, [_vm._v("售后信息")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "shelves-table"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', {
    staticClass: "order-tbody"
  }, [_c('tr', {
    staticClass: "order-table-item"
  }, [_c('td', {
    staticClass: "order-table-image"
  }, [_c('div', {
    staticClass: "order-table-image-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.refundInfo.goodsImage
    },
    on: {
      "error": function($event) {
        return _vm.error(1)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "order-goods-name"
  }, [_vm._v(_vm._s(_vm.refundInfo.goodsName))]), _vm._v(" "), _c('div', {
    staticClass: "order-default-font order-guige"
  }, [_vm._v(_vm._s(_vm.refundInfo.specName))])])]), _vm._v(" "), _c('td', {
    staticClass: "order-default-font"
  }, [_vm._v("¥" + _vm._s(_vm.refundInfo.goodsSalePrice / 100) + " X " + _vm._s(_vm.refundInfo.quantity) + "(数量)")]), _vm._v(" "), _c('td', {
    staticClass: "order-default-font"
  }, [_vm._v("¥" + _vm._s(_vm.refundInfo.needRefund / 100))]), _vm._v(" "), _c('td', {
    staticClass: "order-default-font"
  }, [_vm._v("¥" + _vm._s(_vm.refundInfo.needRefundFreight / 100))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "afs-content-wrap mar-bot-20 no-border"
  }, [_c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("售后类型：")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "afs-form-check",
    class: {
      'checked': _vm.isRefund == 1
    },
    attrs: {
      "disabled": _vm.status == 2
    },
    on: {
      "click": _vm.handleIsRefund
    }
  }, [_vm._v("\n                  仅退款\n                  "), _c('a', {
    class: {
      'checked': _vm.isRefund == 1
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "afs-form-check",
    class: {
      'checked': _vm.isRefund == 2
    },
    attrs: {
      "disabled": _vm.status == 2
    },
    on: {
      "click": _vm.handleIsRefund
    }
  }, [_vm._v("\n                  退货退款\n                  "), _c('a', {
    class: {
      'checked': _vm.isRefund == 2
    }
  })])])]), _vm._v(" "), (_vm.isRefund == 2) ? _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("退货数量：")]), _vm._v(" "), _c('div', [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": _vm.max ? _vm.max.refundAmount : null,
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.num1),
      callback: function($$v) {
        _vm.num1 = $$v
      },
      expression: "num1"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(" (最多可退" + _vm._s(_vm.max ? _vm.max.refundAmount : null) + "件)")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("退款金额：")]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#fea923",
      "font-size": "18px",
      "vertical-align": "bottom"
    }
  }, [_vm._v("¥")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px",
      "color": "#FF0000"
    },
    attrs: {
      "min": 0,
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.backMoney),
      callback: function($$v) {
        _vm.backMoney = $$v
      },
      expression: "backMoney"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "rgb(221, 221, 221)"
    }
  }, [_vm._v("此金额不含运费,最多可退¥ " + _vm._s(this.max.refundMoney2))])]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("是否退运费:")]), _vm._v(" "), _c('div', {
    staticClass: "cl",
    staticStyle: {
      "height": "26px",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "disabled": _vm.status == 2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.isRefundPostage),
      callback: function($$v) {
        _vm.isRefundPostage = $$v
      },
      expression: "isRefundPostage"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.isRefundPostage),
      callback: function($$v) {
        _vm.isRefundPostage = $$v
      },
      expression: "isRefundPostage"
    }
  }, [_vm._v("否")])], 1)]), _vm._v(" "), (_vm.isRefundPostage == 1) ? _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("运费退款:")]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#fea923",
      "font-size": "18px",
      "vertical-align": "bottom"
    }
  }, [_vm._v("¥")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px",
      "color": "#FF0000"
    },
    attrs: {
      "min": 0,
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.refundPostage),
      callback: function($$v) {
        _vm.refundPostage = $$v
      },
      expression: "refundPostage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "rgb(221, 221, 221)"
    }
  }, [_vm._v("目前最多可退¥ " + _vm._s(this.max.refundFreight2))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("是否协议退款:")]), _vm._v(" "), _c('div', {
    staticClass: "cl",
    staticStyle: {
      "height": "26px",
      "display": "flex",
      "padding-left": "15px",
      "align-items": "center"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.refundType),
      callback: function($$v) {
        _vm.refundType = $$v
      },
      expression: "refundType"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": _vm.status == 2
    },
    model: {
      value: (_vm.refundType),
      callback: function($$v) {
        _vm.refundType = $$v
      },
      expression: "refundType"
    }
  }, [_vm._v("否")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("退款说明：")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.reason,
      attrs: {
        "label": item.reason,
        "value": item.reason
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', [_vm._v("问题描述：")]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.desc),
      callback: function($$v) {
        _vm.desc = $$v
      },
      expression: "desc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "afs-tip"
  }, [_vm._v("不超过300字")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', {
    staticStyle: {
      "background-image": "none"
    }
  }, [_vm._v("图片信息：")]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "list-type": "picture-card",
      "accept": "image/*",
      "auto-upload": false,
      "file-list": _vm.fileList,
      "on-preview": _vm.handlePictureCardPreview,
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "afs-tip text-left"
  }, [_vm._v("图片最多上传3张，每张图片大小不超过5M")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "hot-search mar-left-10",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.saveAfs
    }
  }, [_vm._v("确认提交")])], 1)])]) : _c('div', [(_vm.afterSalesDetail.sendBack == 0 && _vm.afterSalesDetail.isRefund == 2 && _vm.afterSalesDetail.status != 3 && _vm.afterSalesDetail.status != 4) ? _c('div', {
    staticClass: "afs-content-wrap padding-bot-20 mar-bot-20"
  }, [_c('div', [_c('div', {
    staticClass: "return-info"
  }, [_c('span', [_vm._v("收件人电话：" + _vm._s(_vm.address.mobile))]), _vm._v(" "), _c('span', {
    staticClass: "main-header-login"
  }, [_vm._v("收件人：" + _vm._s(_vm.address.linkMan))])]), _vm._v(" "), _c('div', {
    staticClass: "return-info"
  }, [_vm._v("收件人地址：" + _vm._s(_vm.address.province + _vm.address.city + _vm.address.area + _vm.address.address))]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', {
    staticClass: "afs-inwrap"
  }, [_vm._v("物流公司：")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择物流公司"
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  }, _vm._l((_vm.logisticsData), function(item) {
    return _c('el-option', {
      key: item.companyNo,
      attrs: {
        "label": item.companyName,
        "value": item.companyNo
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('label', {
    staticClass: "afs-inwrap"
  }, [_vm._v("物流单号：")]), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "请输入物流单号"
    },
    model: {
      value: (_vm.logisticsSn),
      callback: function($$v) {
        _vm.logisticsSn = $$v
      },
      expression: "logisticsSn"
    }
  }), _vm._v(" "), _vm._m(10)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-item"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.saveLogistics
    }
  }, [_vm._v("确认提交")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mar-bot-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "afs-content-wrap padding-bot-20 mar-bot-20"
  }, [_c('div', {
    staticClass: "afs-left"
  }, [_c('div', {
    staticClass: "afs-infor-wrap"
  }, [_c('div', {
    staticClass: "afs-block-title"
  }, [_vm._v("售后信息")]), _vm._v(" "), _c('div', {
    staticClass: "afs-infor"
  }, [_c('div', [_vm._v("退款理由： " + _vm._s(_vm.afterSalesDetail.applicationReason))]), _vm._v(" "), _c('div', [_vm._v("退款金额： ¥" + _vm._s(_vm.afterSalesDetail.refundFee / 100))]), _vm._v(" "), _c('div', [_vm._v("退货数量：" + _vm._s(_vm.afterSalesDetail.refundAmount))]), _vm._v(" "), (_vm.afterSalesDetail.isRefund == 1) ? _c('div', [_vm._v("售后类型： 退款")]) : _c('div', [_vm._v("售后类型： 退货退款")]), _vm._v(" "), _c('div', {
    staticClass: "afs-infor-item"
  }, [_c('a', [_vm._v("退款说明：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.afterSalesDetail.userReason))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "afs-right"
  }, [_c('div', {
    staticClass: "afs-image"
  }, [_c('div', {
    staticClass: "afs-block-title mar-bot-20"
  }, [_vm._v("售后图片")]), _vm._v(" "), _c('div', {
    staticClass: "afs-image-list"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.afterSalesDetail.imgProof1
    },
    on: {
      "error": function($event) {
        return _vm.error(2)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.afterSalesDetail.imgProof2
    },
    on: {
      "error": function($event) {
        return _vm.error(2)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.afterSalesDetail.imgProof3
    },
    on: {
      "error": function($event) {
        return _vm.error(2)
      }
    }
  })])])])])])]), _vm._v(" "), (_vm.afterSalesDetail.sendBack == 0 && _vm.afterSalesDetail.isRefund == 2 && _vm.afterSalesDetail.status != 1) ? _c('div', {
    staticClass: "afs-content-wrap padding-bot-20 mar-bot-20"
  }, [_c('div', [_c('div', {
    staticClass: "return-info"
  }, [_c('span', [_vm._v("收件人电话：" + _vm._s(_vm.address.mobile))]), _vm._v(" "), _c('span', {
    staticClass: "main-header-login"
  }, [_vm._v("收件人：" + _vm._s(_vm.address.linkMan))])]), _vm._v(" "), _c('div', {
    staticClass: "return-info"
  }, [_vm._v("收件人地址：" + _vm._s(_vm.address.province + _vm.address.city + _vm.address.area + _vm.address.address))]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-items"
  }, [_c('label', {
    staticClass: "afs-inwrap"
  }, [_vm._v("物流公司：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.afterSalesDetail.courierCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "afs-form-items"
  }, [_c('label', {
    staticClass: "afs-inwrap"
  }, [_vm._v("物流单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.afterSalesDetail.courierNumber))])])])]) : _vm._e(), _vm._v(" "), (_vm.showRefundList) ? _c('div', {
    staticClass: "afs-content-wrap padding-bot-20 mar-bot-20"
  }, [_c('div', [_vm._v("该笔订单下的售后单")]), _vm._v(" "), _c('table', {
    staticClass: "shelves-table no-margin"
  }, _vm._l((_vm.refundList), function(item) {
    return _c('tbody', {
      staticClass: "order-tbody"
    }, [_vm._m(11, true), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "shelves-table-block-title no-select",
      attrs: {
        "colspan": "7"
      }
    }, [_c('span', [_vm._v("售后单号：" + _vm._s(item.afterSn))]), _vm._v(" "), _c('span', [_vm._v("订单号：" + _vm._s(item.orderInfoSn))]), _vm._v(" "), _c('span', [_vm._v("下单时间：" + _vm._s(item.orderCreateTime))]), _vm._v(" "), (item.status == 2) ? _c('span', [_vm._v("订单状态：待发货")]) : (item.status == 3) ? _c('span', [_vm._v("订单状态：待收货")]) : _c('span', [_vm._v("订单状态：已收货")]), _vm._v(" "), _c('span', [_vm._v("收货人电话：" + _vm._s(item.mobile))]), _vm._v(" "), _c('span', [_vm._v("售后时间：" + _vm._s(item.afterCreateTime))])])]), _vm._v(" "), _c('tr', {
      staticClass: "order-table-item"
    }, [_c('td', {
      staticClass: "order-table-image"
    }, [_c('div', {
      staticClass: "order-table-image-wrap"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.goodsImage
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    }), _vm._v(" "), (item.isOwns > 0) ? _c('img', {
      staticStyle: {
        "width": "22px",
        "height": "22px",
        "position": "absolute",
        "z-index": "100",
        "top": "initial",
        "left": "0"
      },
      attrs: {
        "src": require("../assets/img/is_owns.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "order-goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "order-default-font order-guige"
    }, [_vm._v(_vm._s(item.specName))])])]), _vm._v(" "), _c('td', {
      staticClass: "order-default-font"
    }, [_c('div', [_vm._v("¥" + _vm._s(item.refundFee / 100))]), _vm._v(" "), _c('div', {
      staticClass: "order-item-time"
    }, [_vm._v("（含运费：¥" + _vm._s(item.refundPostage / 100) + ")")])]), _vm._v(" "), _c('td', {
      staticClass: "order-default-font"
    }, [_vm._v(_vm._s(item.refundAmount))]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.applicationReason))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.refundType))])]), _vm._v(" "), _c('td', [(item.status == 1 || item.status == 5) ? _c('div', [_vm._v("商家已受理")]) : (item.status == 2) ? _c('div', [_vm._v("商家已同意")]) : (item.status == 3) ? _c('div', [_vm._v("商家退款成功")]) : _c('div', [_vm._v("商家拒绝")])]), _vm._v(" "), _c('td', {
      staticClass: "order-toDetail"
    }, [_c('router-link', {
      staticClass: "font-color-orange cursor-pointer",
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'AfterSale',
          query: {
            id: item.afterSalesId
          }
        }
      }
    }, [_vm._v("查看售后详情")])], 1)])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "afs-content-wrap padding-bot-20 mar-bot-20"
  }, [_c('div', [_vm._v("订单信息")]), _vm._v(" "), _c('table', {
    staticClass: "shelves-table"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', {
    staticClass: "order-tbody"
  }, [_vm._m(13), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "shelves-table-block-title no-select",
    attrs: {
      "colspan": "7"
    }
  }, [_c('span', [_vm._v("订单号：" + _vm._s(_vm.orderInfo.orderSn))]), _vm._v(" "), _c('span', [_vm._v("下单时间：" + _vm._s(_vm.orderInfo.createTime))])])]), _vm._v(" "), _vm._l((_vm.goodsInfo), function(item, index) {
    return _c('tr', {
      staticClass: "order-table-item"
    }, [_c('td', {
      staticClass: "order-table-image"
    }, [_c('div', {
      staticClass: "order-table-image-wrap"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.navigateImg1
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    }), _vm._v(" "), (item.isOwns > 0) ? _c('img', {
      staticStyle: {
        "width": "22px",
        "height": "22px",
        "position": "absolute",
        "z-index": "100",
        "top": "initial",
        "left": "0"
      },
      attrs: {
        "src": require("../assets/img/is_owns.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "order-goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "order-default-font order-guige"
    }, [_vm._v(_vm._s(item.specName))])])]), _vm._v(" "), _c('td', [_c('div', [_vm._v("¥" + _vm._s(item.salePrice / 100))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.quantity))])]), _vm._v(" "), (index == 0) ? _c('td', {
      attrs: {
        "rowspan": _vm.goodsInfo.length
      }
    }, [_c('div', [_vm._v("¥" + _vm._s(item.totalFee / 100) + "(含运费¥" + _vm._s(_vm.orderInfo.freight / 100) + ")")])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "afs-content-wrap padding-bot-20 mar-bot-20"
  }, [_c('div', [_vm._v("买家信息")]), _vm._v(" "), _c('div', {
    staticClass: "afs-infor"
  }, [_c('div', [_vm._v("客户收货地址： " + _vm._s(_vm.addressInfo.province + _vm.addressInfo.city + _vm.addressInfo.area + _vm.addressInfo.address))]), _vm._v(" "), _c('div', [_vm._v("客户姓名： " + _vm._s(_vm.addressInfo.linkMan))]), _vm._v(" "), _c('div', [_vm._v("客户手机号： " + _vm._s(_vm.addressInfo.mobile))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "order-detail-one order-status-one order-status-default yiwancheng"
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("提交申请")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("售后完成")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("商家退款")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("商家退款")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("商家处理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("商家同意")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                        收货方式：\n                        "), _c('span', [_vm._v("普通快递")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("商家拒绝")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "afs-content"
  }, [_c('div', {
    staticClass: "afs-content-title"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("提交申请")])]), _vm._v(" "), _c('div', {
    staticClass: "afs-content-info"
  }, [_c('div', {
    staticClass: "afs-content-info-wrap"
  }, [_c('div', {
    staticClass: "order-status-text big-font"
  }, [_vm._v("处理信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("申请已提交，平台会在1-2个工作日内处理")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v("处理方：系统")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品信息")]), _vm._v(" "), _c('th', [_vm._v("单价")]), _vm._v(" "), _c('th', [_vm._v("可退款金额")]), _vm._v(" "), _c('th', [_vm._v("运费")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('i', {
    staticClass: "el-icon-information"
  }), _vm._v("请将商品邮寄到上面地址，并填写物流公司，物流单号\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "self-tbody-space",
    attrs: {
      "colspan": "7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品信息")]), _vm._v(" "), _c('th', [_vm._v("单价")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("订单实际金额")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "self-tbody-space",
    attrs: {
      "colspan": "7"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15f6ff1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AfterSale.vue
// module id = 517
// module chunks = 1